/**
 * 财务管理 用户卡信息
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户卡信息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.shop_name" placeholder="商家名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input size="small" v-model="formInline.mobile" placeholder="银行预留手机号"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="info" icon="el-icon-refresh" native-type="reset" @click="resetForm">重置</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="信息卡ID" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="name" label="商家" width="210" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="user_name" label="用户名称" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="bank_phone" label="银行手机号" width="120" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="bank_name" label="银行名称" width="170" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="card_num" label="银行卡号" width="210" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="bank_code" label="银行代码" width="120" show-overflow-tooltip>
      </el-table-column>

      <el-table-column align="center" label="操作" min-width="150" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)" type="warning" icon="el-icon-edit">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>

    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" ref="editForm">
        <el-row>
          <el-form-item label="用户信息卡ID">
              <el-input size="small" v-model="editForm.id" auto-complete="off" placeholder="请输入名称" disabled></el-input>
            </el-form-item>
            <el-form-item label="商家名称">
              <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入商户号" disabled></el-input>
            </el-form-item>
            <el-form-item label="持卡人姓名">
              <el-input size="small" v-model="editForm.user_name" auto-complete="off" placeholder="请输入商户号" ></el-input>
            </el-form-item>
            <el-form-item label="银行卡手机号">
              <el-input size="small" v-model="editForm.bank_phone" auto-complete="off" placeholder="请输入微信子商户" ></el-input>
            </el-form-item>
            <el-form-item label="银行卡号">
              <el-input size="small" v-model="editForm.card_num" auto-complete="off" placeholder="请输入应用ID" ></el-input>
            </el-form-item>
        </el-row>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="submitForm">提交</el-button>
          <el-button size="small" type="info" icon="el-icon-refresh" native-type="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { OrderList, OrderRefund, OrderDelete } from '../../api/payMG'
import Pagination from '../../components/Pagination'
import {editUserCard, userCardList} from "../../api/money";
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '编辑',
      editForm: {
        id: '',
        name: '',
        user_name: '',
        card_num: '',
        bank_phone: ''
      },
      formInline: {
        page: 1,
        limit: 10,
        shop_name: '',
        mobile: '',
        org_id: this.$globalConfig.orgId,
      },

      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  created() {
    this.getdata(this.formInline)
  },

  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      userCardList(parameter)
        .then(res => {
          this.loading = false
          if (res.code !== 1) {
            this.$message({
              type: 'info',
              message: res.msg
            })
          } else {
            this.listData = res.data.data
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('菜单加载失败，请稍后再试！')
        })
    },

    //重置
    resetForm() {
      this.formInline.page = 1
      this.formInline.limit = 10
      this.formInline.mobile = ''
      this.formInline.shaop_name = ''
      this.getdata(this.formInline)
    },

    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },

    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      this.editForm = row
    },

    // 编辑页面
    submitForm(){
      this.loading = true
      editUserCard(this.editForm)
        .then(res => {
          this.editFormVisible = false
          this.loading = false
          if (res.code === 1) {
            this.getdata(this.formInline)
            this.$message({
              type: 'success',
              message: '编辑成功！'
            })
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.editFormVisible = false
          this.loading = false
          this.$message.error('编辑失败，请稍后再试！')
        })
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/money/Card.vue